import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
    message?: string;
    onRetry?: () => void;
    className?: string;
}

export const ErrorState = ({
    message,
    onRetry,
    className = 'h-64',
}: ErrorStateProps) => {
    const { t } = useTranslation('codPayouts');
    const displayMessage = message || t('error.default');

    return (
        <div
            className={`flex items-center justify-center transition-colors ${className}`}
        >
            <div className="text-center">
                <AlertCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
                <p className="text-foreground font-medium mb-2">{t('error.title')}</p>
                <p className="text-muted-foreground text-sm mb-4">{displayMessage}</p>
                {onRetry && (
                    <button
                        onClick={onRetry}
                        className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
                    >
                        {t('error.retry')}
                    </button>
                )}
            </div>
        </div>
    );
};
